import { useEffect } from 'react';
import { hookstate, useHookstate } from '@hookstate/core';
import { useConfig, useEspot } from '~/store/Query/api';
import orderedAlphabetical from "~/helpers/orderings";

export const pickupInStoreState = hookstate(false);
export const pickupStore = hookstate(null);

export const cuotaState = hookstate({
  banks: [],
  affiliations: [],
  cuotas: null,
});

export const formCustom = new Set([
  'dpiConfirm',
  'id',
  'nit',
  'day',
  'month',
  'year',
  'invoice_type',
  'fiscal_number',
  'turn',
  'document_type',
  'departamento_fiscal',
  'municipio_fiscal',
  'passport_country',
  'departamentoid',
  'municipioid',
  'pobladoid',
]);

export const formShipping = new Set([
  'first_name',
  'last_name',
  'address_line_1',
  'phone_1',
  'state_or_province_name',
  'city',
  'address_line_2',
  'email_1',
  'allowed_recipient_1',
  'fax_1',
]);

export const sessionInfo = () => {
  const sessionCustom = Array.from(formCustom).reduce((acc, key) => {
    const value = sessionStorage.getItem(`form_custom_info.${key}`);
    if (value) {
      acc[key] = value;
    }
    return acc;
  }, {});
  const sessionShipping = Array.from(formShipping).reduce((acc, key) => {
    const value = sessionStorage.getItem(`form_shipping_info.${key}`);
    if (value) {
      acc[key] = value;
    }
    return acc;
  }, {});
  const sessionBilling = [
    'address_line_1',
  ].reduce((acc, key) => {
    const value = sessionStorage.getItem(`form_billing_info.${key}`);
    if (value) {
      acc[key] = value;
    }
    return acc;
  }, {});
  return { sessionCustom, sessionShipping, sessionBilling };
};

export const useFormOrder = () => {
  const config = useEspot('formularios-direcciones');
  const state = useHookstate();
  useEffect(() => {
    if (config.data?.ok) {
      state.set(config.data.body);
    }
  }, [config.data]);
  return state;
};

export const useDeptos = (
  configName = 'departamentos',
  deptoId = 'depto_name',
  deptoName = 'depto_name',
  mpoName = 'mpo_name',
  pobName = 'pob_name'
) => {
  const config = useConfig(configName);
  const deptos = useHookstate([]);
  const mpos = useHookstate({});
  useEffect(() => {
    if (config.data?.ok) {
      const { data } = config.data.body;
      orderedAlphabetical(data, deptoName);
      data.forEach((depto) => {
        if (depto.mpos) {
          orderedAlphabetical(depto.mpos, mpoName);
          depto.mpos.forEach((mpo) => {
            if (mpo.pob) {
              orderedAlphabetical(mpo.pob, pobName);
            }
          });
          mpos.nested(depto[deptoId]).set(depto.mpos);
        }
      });
      deptos.set(data);
    }
  }, [config.data]);
  return [deptos, mpos];
};
